var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.64 2.16C18.64 2.88 18.12 3.32 17.44 3.48C15.4 3.96 14.28 5.36 14.36 7.28C15.76 7.64 17.16 8.84 17.16 10.56V10.64C17.16 12.52 15.84 13.92 13.84 13.92C11.6 13.92 10.28 12.2 10.28 9.44V9.28C10.28 6.36 11.16 4.2 12.64 2.72C13.84 1.52 15.64 0.799998 17.12 0.799998C18.2 0.799998 18.64 1.44 18.64 2.16ZM8.48 2.16C8.48 2.88 7.96 3.32 7.28 3.48C5.24 3.96 4.12 5.36 4.2 7.28C5.6 7.64 7 8.84 7 10.56V10.64C7 12.52 5.68 13.92 3.68 13.92C1.44 13.92 0.12 12.2 0.12 9.44V9.28C0.12 6.36 1 4.2 2.48 2.72C3.68 1.52 5.48 0.799998 6.96 0.799998C8.04 0.799998 8.48 1.44 8.48 2.16Z",
    fill: "#1429B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation);
export default __webpack_public_path__ + "static/media/quotation.97bdae59ee5dc0321a888267d384170b.svg";
export { ForwardRef as ReactComponent };